import { wrap as withStyle } from 'utils/styles'

export default withStyle((props) => {
  const inputWidth = props.short ? 53 : 83

  return `
    input {
      width: ${inputWidth}px;
    }
  `
})
